<template>
  <CenterLayout>
    <DefaultCard>
      <template #title>
        {{ $t('selfRegistrationTitle') }}
      </template>
      <template v-if="!success">
        <v-form v-model="valid" @submit.prevent="submit">
          <v-card-text>
            <p>{{ $t('selfRegistrationText') }}</p>
            <p v-if="config.privacy_policy" v-dompurify-html="config.privacy_policy" />
            <v-text-field
              ref="email"
              v-model="form.email"
              label="E-Mail Adresse"
              autofocus
              :error-messages="errors.email"
              :rules="[$options.rules.email]"
              @input="clearErrors"
            />
            <div v-if="config.self_registration_condition" class="d-flex align-start">
              <v-checkbox id="condition-text" class="ma-0 pa-0" :rules="[$options.rules.approval]" />
              <label
                v-dompurify-html="config.self_registration_condition"
                for="condition-text"
                style="white-space: pre-line"
              />
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn depressed :to="{ name: 'login' }">{{ $t('cancel') }}</v-btn>
            <v-btn depressed type="submit" color="primary" min-width="120" :loading="loading" :disabled="!valid">
              {{ $t('selfRegistrationRegister') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </template>
      <template v-if="success">
        <v-card-text>
          <i18n path="selfRegistrationEmailSent" tag="p" class="body-1" data-testid="logged-in-message">
            <template v-slot:email>
              <b>{{ form.email }}</b>
            </template>
          </i18n>
        </v-card-text>
      </template>
    </DefaultCard>
  </CenterLayout>
</template>

<script>
import api from '@/api'
import { branding } from '@/components/mixins'
import DefaultCard from '@/components/DefaultCard'
import CenterLayout from '@/layouts/center'

export default {
  name: 'SelfRegistration',
  components: { DefaultCard, CenterLayout },
  mixins: [branding],
  rules: {
    approval: (value) => value === true,
    email: (value) => value.includes('@'),
  },
  data() {
    return {
      form: {
        email: '',
      },
      valid: null,
      loading: false,
      success: false,
      errors: {},
    }
  },
  mounted() {
    this.$refs.email.focus()
  },
  methods: {
    async submit() {
      this.loading = true
      try {
        await api.post('/api/registration/self-registration', this.form)
        this.success = true
      } catch ({ response: { data } }) {
        this.errors = data
      }
      this.loading = false
    },
    clearErrors() {
      this.errors = {}
    },
  },
}
</script>
